import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import Switch from '@ls/react-switch';
import { selectSelectedIsShowCanceledTrades } from 'state/selections/selectors';
import SelectionState from 'state/selections/SelectionState';
import { setIsShowCanceledTrades } from 'state/selections/actions';

const ShowCanceledTradesSwitch = props => {
  const dispatch = useDispatch();
  const checked = useSelector(
    selectSelectedIsShowCanceledTrades(SelectionState.UNCOMMITTED)
  );

  const onChange = React.useCallback(
    isShowCanceledTrades => dispatch(setIsShowCanceledTrades(isShowCanceledTrades)),
    [dispatch]
  );

  return <Switch label="Show Canceled Trades" 
                 value={checked} 
                 onChange={onChange}
                 raised
        />;
};

ShowCanceledTradesSwitch.propsTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

export default ShowCanceledTradesSwitch;
